(function (Drupal, $) {

    $(function () {

        $.urlParam = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                              .exec(window.location.search);

            return (results !== null) ? results[1] || 0 : false;
        }


        var messagesWrapper = $('.messages-wrapper')

        if (messagesWrapper.length && $.urlParam('logout')) {
            document.body.classList.add('logged-out')
            messagesWrapper.append('<div class="messages messages--error"><div class="logout-success">You’re now logged out</div></div>')
        }

    });


  })(Drupal, jQuery);
